
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Tabla from "../common/ManageTabla";

const InsigniaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, 
                     headersTablaHabilidades, camposTablaHabilidades, validacionesTablaHabilidades, 
                     tipoTablaHabilidades, cursoCombo, insigniaCombo, 
                     datos, errors={}, strings, permisos, archivos})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Insignia"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["descripcion"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["descripcion"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.beneficios}>            
                              <label  >{strings?strings["beneficios"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["beneficios"]:""} 
                                    name="beneficios"
                                    onChange={onChange}
                                    value={datos.beneficios}
                                    icon='edit'/>
                            </Form.Field>
                                 
        
                            <Form.Field  required  error={errors.imagenInsignia}>
                              <label  >{strings?strings["imagenInsignia"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["imagenInsignia"]:""} 
                                    name="imagenInsignia"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.imagenInsignia}
                                    options={archivos}/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.idsHabilidades}>
                                <label  >{strings?strings["idsHabilidades"]:""}</label>
                                <Tabla 
                                    nombre="idsHabilidades"
                                    tipoTablaModulos={tipoTablaHabilidades}
                                    

                                    headers={headersTablaHabilidades}
                                    campos={camposTablaHabilidades}
                                    validaciones={validacionesTablaHabilidades}
                                />  
                            </Form.Field>
        
        
                       
                                            
                            <Form.Field  required  error={errors.idsCursos}>
                              <label  >{strings?strings["idsCursos"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsCursos"]:""} 
                                    name="idsCursos"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsCursos}
                                    options={cursoCombo}/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.idsCursos}>
                              <label  >{strings?strings["idsInsigniasRequeridas"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsInsigniasRequeridas"]:""} 
                                    name="idsInsigniasRequeridas"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsInsigniasRequeridas}
                                    options={insigniaCombo}/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/insignias">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default InsigniaForm;